import { render } from "./SolutionsHome.vue?vue&type=template&id=6638f942&scoped=true"
import script from "./SolutionsHome.vue?vue&type=script&lang=js"
export * from "./SolutionsHome.vue?vue&type=script&lang=js"

import "./SolutionsHome.vue?vue&type=style&index=0&id=6638f942&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6638f942"]])

export default __exports__